export default __webpack_public_path__ + "static/media/consumable_img.958bdd68.png";